import React from 'react';

import { flagStyles } from '../settings';

const SvgCU = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-1176px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgCU;
